import { ApiSubUrls, Apis } from 'enums/api-constants'
import { fetchGeneralData } from 'queries/fetchData'
import { Metric } from 'pages/myTarget-performance/types'
import { TableData } from 'utils/data'

export const fetchMyTargetPerformanceMetricInfo = fetchGeneralData<Metric[]>(
    `${ApiSubUrls[Apis.PERFORMANCE_METRICS]}`,
)

export const fetchMyTargetPerformanceGuestMetrics = fetchGeneralData<TableData>(
    `${ApiSubUrls[Apis.AGGREGATIONS]}/greenfield/cards/`,
)

export const fetchMyTargetPerformanceGuestGoals = fetchGeneralData<TableData>(
    `${ApiSubUrls[Apis.AGGREGATIONS]}/greenfield/cards/`,
)

export const fetchMyTargetPerformanceFinancialMetrics =
    fetchGeneralData<TableData>(
        `${ApiSubUrls[Apis.AGGREGATIONS]}/greenfield/cards/`,
    )

export const fetchMyTargetPerformanceFinancialGoals =
    fetchGeneralData<TableData>(
        `${ApiSubUrls[Apis.AGGREGATIONS]}/greenfield/cards/`,
    )

export const fetchMyTargetPerformanceTeamMetrics = fetchGeneralData<TableData>(
    `${ApiSubUrls[Apis.AGGREGATIONS]}/greenfield/cards/`,
)

export const fetchMyTargetPerformanceTeamGoals = fetchGeneralData<TableData>(
    `${ApiSubUrls[Apis.AGGREGATIONS]}/greenfield/cards/`,
)

export const fetchMyTargetPerformanceGreenStores = fetchGeneralData<TableData>(
    `${ApiSubUrls[Apis.AGGREGATIONS]}/greenfield/cards/`,
)

export const fetchMyTargetPerformanceCard = fetchGeneralData<TableData>(
    `${ApiSubUrls[Apis.AGGREGATIONS]}/greenfield/cards/`,
)

export const fetchMyTargetPerformanceStores = fetchGeneralData<TableData>(
    `${ApiSubUrls[Apis.AGGREGATIONS]}/my_target_performance/stores`,
)
